{
  "actions": "Действия",
  "actionsAvailable": "Возможно выполнение действий.",
  "clearSelection": "Очистить выбор",
  "selected": "{count, plural, =0 {Ничего не выбоано} other {# выбрано}}",
  "selectedAll": "Выбрано все"
}
